module.exports = __webpack_public_path__ + "media/images/icon_category02-4496f1de068f320670f298b330298b4b.png";